export default () => ({
  isFetched: false,
  flags: {
    signup_campaign_active: false,
    signup_campaign_active_last_day: false
  }
})
